import { useEffect, useRef } from 'react';
export function useForwardedRef(forwardedRef) {
    var targetRef = useRef();
    useEffect(function () {
        if (forwardedRef) {
            if (typeof forwardedRef === 'function') {
                forwardedRef(targetRef.current);
            }
            else {
                forwardedRef.current = targetRef.current;
            }
        }
    });
    return targetRef;
}
//# sourceMappingURL=useForwardedRef.js.map